import { Grid } from '@mantine/core';
import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { NotFound } from 'src/components/NotFound';
import { links } from 'src/router/routes';

import { AddBox } from '../AddBox';
import { InteractionDictionaryBox } from '../Box';

type InteractionProps = {
  id: number;
  imageSrc: string;
  name: string;
  description: string;
};

type Props = {
  interactions: InteractionProps[];
};

export const InteractionDictionaryList = ({
  interactions,
}: PropsWithChildren<Props>) => {
  const navigate = useNavigate();

  if (!interactions.length) {
    return (
      <NotFound
        description="No interactions found"
        onButtonClick={() => navigate(links.interactionDictionaryNew)}
        buttonText="Add new interaction"
      />
    );
  }

  return (
    <Grid>
      <Grid.Col span={{ base: 12, lg: 4, md: 6, xl: 3, xxl: 2 }}>
        <AddBox />
      </Grid.Col>
      {interactions.map(({ id, name, description }) => (
        <Grid.Col span={{ base: 12, lg: 4, md: 6, xl: 3, xxl: 2 }} key={id}>
          <InteractionDictionaryList.Box
            id={id}
            name={name}
            description={description}
          />
        </Grid.Col>
      ))}
    </Grid>
  );
};

InteractionDictionaryList.Box = InteractionDictionaryBox;
